import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Store } from '@ngrx/store';
import { LogoutRequest, LogoutSuccess } from '../../store/auth/auth.actions';
import { Actions, ofType } from '@ngrx/effects';
import { selectUser } from '../../store/user/user.selectors';
import { BRANDING } from '../../core/config/branding';

@Component({
  selector: 'app-super-admin-shell',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive, MatButtonModule, MatIconModule],
  templateUrl: './super-admin-shell.html',
  styleUrl: './super-admin-shell.scss',
})
export class SuperAdminShell {
  protected readonly brand = BRANDING;
  private readonly store = inject(Store);
  private readonly router = inject(Router);
  private readonly actions$ = inject(Actions);
  private readonly destroyRef = inject(DestroyRef);

  protected readonly currentUserName = signal('Super Admin');

  ngOnInit(): void {
    this.store.select(selectUser)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((user) => {
        this.currentUserName.set(user?.name?.trim() || 'Super Admin');
      });
  }

  protected logout(): void {
    this.store.dispatch(LogoutRequest());
    this.actions$.pipe(ofType(LogoutSuccess), takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      void this.router.navigate(['/auth/login']);
    });
  }
}
